import React, { useState, useEffect } from "react";

import DashboardHeader from "../../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../../DashboardReuseAbleComponents/DashboardSideMenu";
import ShowProfileModal from "../../CardDetail/ShowProfileModal";
import { useLocation, Link } from "react-router-dom";
import { addServiceValidate } from './addServiceValidate';
import AddConsultantServiceForm from "./AddConsultantServiceForm";

// Styles
import styles from "./ConsultantReportsServiceDetails.module.css";

// Images
import arrowIcon from "./../../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ConsultantReportsServiceAdd = (props) => {
    const { state } = useLocation();
    const [modalShow, setModalShow] = useState(false);
    const history = useHistory();
    const [errors, setErrors] = useState({})
    const [formValue, setFormValue] = useState({
        ownerName: "",
        ownerPhone: "",
        customerName: "",
        customerPhone: "",
        code: "",
        price: "",
        area: "",
        date: "",
        time: "",
        result: "",
    })

    useEffect(() => {
        setErrors(addServiceValidate(formValue))
        // console.log(errors)
    }, [formValue])

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`my-3 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href="#" onClick={history.goBack}>
                                        <img className='ms-2 pointer' src={arrowIcon} alt="icon" />
                                    </a>
                                    <div className={styles.text1}>
                                        افزودن کارت سرویس
                                    </div>
                                </div>
                            </div>

                            {/* Total Form Consultant Reports Expert Report Details */}
                            <AddConsultantServiceForm formValue={formValue} setFormValue={setFormValue} errors={errors} id={state} />

                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsultantReportsServiceAdd;

